import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography, useTheme } from '@mui/material'
import { Calendar } from '@styled-icons/heroicons-outline'

import { formatDateToFEFormatDateFns } from 'utils/date'

const DisplayField = ({ startDate, endDate, onCalendarOpen, ...rest }) => {
  const theme = useTheme()

  return (
    // HHTextField create cursor problem, so using custom Box
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      height={40}
      px={2}
      bgcolor="background.paper"
      gap={3}
      onClick={onCalendarOpen}
      cursor="pointer"
      border="1px solid"
      borderColor="divider"
      borderRadius={2}
      {...rest}
    >
      <Typography sx={{ cursor: 'pointer' }}>
        {`${formatDateToFEFormatDateFns(startDate)} - ${formatDateToFEFormatDateFns(endDate)}`}
      </Typography>
      <Calendar width={24} height={24} color={theme.palette.action.active} cursor="pointer" />
    </Box>
  )
}

DisplayField.propTypes = {
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onCalendarOpen: PropTypes.func.isRequired,
}

export default DisplayField
